import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.696 5.669 4.281-2.391a.7.7 0 0 1 1.041.61v10.518a1 1 0 0 1-.512.873l-4.329 2.418c-.315.175-.673.118-.913.041a1.025 1.025 0 0 1-.18-.067L7.322 15.38 3.47 17.53a1 1 0 0 1-1.487-.873V6.651a1 1 0 0 1 .512-.873l4.477-2.5c.428-.24.947.078 1.03.132l4.695 2.259Zm-.709 10.291-3.969-1.91V5.083l3.97 1.91v8.967Zm1.531-9.033 3-1.675v8.86l-3 1.676v-8.86Zm-10.036.018v8.86l3.03-1.692V5.252l-3.03 1.693Z"
      fill="#fff"
    />
  </svg>
);

const Memo = memo(SvgMap);

export default Memo;
